import React from "react";
import MainWhiteContainer from "components/Buttons/MainWhiteContainer";
import { Grid, Popup, Card, Confirm, Message, Icon, Label, LabelDetail } from "semantic-ui-react";
import ContainerFieldPrescription from "features/FolderManager/components/Prescription/ContainerFieldPrescription";
import Analysis from "features/FolderManager/components/Prescription/Analysis";
import BlueButton from "components/Buttons/BlueButton";
import EditAnalyses from "features/FolderManager/components/SidebarComp/EditAnalyses";
import { checkMimeType } from "utils/file";
import { toast } from "react-toastify";
import ViewFilesModal from "features/FolderManager/components/modals/ViewFilesModal";
import TakePhotoModal from "features/FolderManager/components/modals/TakePhotoModal";
import AddNurseHelpModal from "features/FolderManager/components/modals/AddNurseHelpModal";
import { b64toFile } from "utils/file";
import BlueButtonEditBloc from "components/Buttons/BlueButtonEditBloc";
import ContainerFieldPrescriptionUrgent from "features/FolderManager/components/Prescription/ContainerFieldPrescriptionUrgent";
import ContainerIconPrescription from "features/FolderManager/components/Prescription/ContainerIconPrescription";
import { isMobile } from "utils/isMobile";
import AnalysisDetailsModal from "features/FolderManager/components/Prescription/AnalysisDetailsModal";
import moment from "moment";
import { formatPhoneNumberToInternational } from "utils/phone";
import ScanContainer from "features/FolderManager/components/scan/ScanContainer";
import SignConsentModal from "../modals/SignConsentModal";
import Separator from "components/Form/Separator";
import DocumentTypeModal from "../modals/DocumentTypeModal";
import QRScanCodeBarreOrdonance from "../modals/QRScanCodeBarreOrdonance";
import { codebarre } from "./defaultCodeBarre";
import { docCodeBar } from "./docCodeBarre";
import { BrowserBarcodeReader } from "@zxing/library";
import { withTranslation } from "react-i18next";
import Documents from "./Documents";
import AddDocsTvSecModal from "../modals/AddDocsTvSecModal";
import isEqual from "lodash.isequal";
import { getPatientHomeAddress } from "utils/address";
import { cleanPhoneNumber } from "utils/phone";

const defaultCodeBarre = codebarre;
const documentCodeBar = docCodeBar;

const styles = {
	title: {
		fontSize: "1em",
		fontWeight: 600,
		marginBottom: 10,
	},

	doctor: {
		fontWeight: 600,
		fontSize: "1em",
		marginBottom: 5,
		display: "flex",
	},
	textField: {
		paddingLeft: 10,
	},
	prescriptionNumber: {
		paddingRight: 10,
	},
	doctorName: {
		textTransform: "uppercase",
	},
	rowNoPadding: {
		paddingTop: 0,
		paddingBottom: 0,
		paddingRight: "1rem",
	},
	rowWithPadding: {
		paddingTop: 14,
		paddingBottom: 0,
		paddingRight: "1rem",
	},
	subTotalContainer: {
		border: "1px solid rgb(200, 200, 200)",
		backgroundColor: "rgb(230, 230, 230)",
		padding: 3,
		boxShadow: "0px 9px 35px -23px rgba(148,148,148,1)",
		borderRadius: 4,
		fontSize: "0.6em",
		width: "fit-content",
		height: "fit-content",
		alignSelf: "flex-end",
		marginLeft: 5,
	},
	subTotalPrice: {
		fontSize: "1em",
		fontWeight: 800,
	},
	positiveContainerField: {
		color: "#098827",
		fontWeight: 600,
	},
};

class Prescription extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			scanPrescriptionModalPopup: false,
			scanPrescriptionViewOpen: false,
			scanId: null,
			takePhotoModal: false,
			qrReaderPrescriptionOpen: false,
			analysisDetailsModal: false,
			helpNurseModal: false,
			analysisDetailed: null,
			hasCameraAccess: false,
			scanDeleteConfirmOpen: false,
			focusedScan: null,
			focusedPageNumber: null,
			signConsentModalOpen: false,
			documentTypeModalOpen: false,
			file: null,
			barcode: null,
			mounted: true,
			openScanOrdo: false,
			movePrescriptionScan: null,
			addDocsModalOpen: false,
		};
	}

	componentDidMount() {
		if (!this.props.documentTypes || !this.props.documentTypes.list || this.props.documentTypes.list.length === 0) {
			this.props.getAllDocumentTypes();
		}
	}

	componentDidUpdate(previousProps) {
		if (!isEqual(previousProps.openScanOrdo, this.props.openScanOrdo)) {
			if (this.props.openScanOrdo && this.props.openScanOrdo.id === this.props.prescription.id)
				this.props.getAllDocumentTypes().then(() => this.setState({ openScanOrdo: true, hasCameraAccess: true }));
			else this.setState({ openScanOrdo: false, hasCameraAccess: false });
		}
	}

	openAnalysesEdit = async (e) => {
		let that = this;
		if (e !== undefined) e.preventDefault();
		await this.props.loadAllAnalysesAndPacks(
			this.props.isHome,
			this.props.folder,
			this.props.patient,
			this.props.prescription.prescriber,
			this.props.center
		);
		this.props.openSidebar(
			<EditAnalyses
				prescription={that.props.prescription}
				library={this.props.analysisLibrary}
				onSubmit={this.props.onAnalysesEditSubmit}
				hideSidebar={this.props.hideSidebar}
				isHome={this.props.isHome}
				showAllCatalog={this.props.center ? this.props.center.showAllCatalog : true}
				createFolderHelp={this.props.createFolderHelp}
				scans={this.props.scans}
				useScanOrdo={this.props.useScanOrdo}
				removeScanOrdo={this.props.removeScanOrdo}
				cleanScans={this.props.cleanScans}
				loadingScans={this.props.loadingScans}
				folder={this.props.folder}
				center={this.props.center}
				role={this.props.role}
				generalParameters={this.props.generalParameters}
				postScanPrescription={this.postScanPrescription}
				dualScreen={this.props.dualScreen}
				secretaries={this.props.secretaries}
				isMobile={isMobile()}
				deleteScanPrescription={this.deleteScanPrescription}
				documentTypes={this.props.documentTypes}
				isDeposit={this.props.isDeposit}
				isDomicile={this.props.center === process.env.REACT_APP_DOMICILE_CENTER}
				checkAnalysis={this.props.checkAnalysis}
			/>
		);
	};

	closeDocumentTypeModal = () => {
		this.setState({ documentTypeModalOpen: false, file: null, barcode: null });
	};

	openDocumentTypeModal = async () => {
		this.setState({ documentTypeModalOpen: true });
	};

	closeScanPrescriptionModalPopup = () => {
		this.setState({ scanPrescriptionModalPopup: false });
	};

	openScanPrescriptionModalPopup = () => {
		this.setState({ scanPrescriptionModalPopup: true });
	};

	toBase64 = (file) =>
		new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = () => resolve(reader.result);
			reader.onerror = (error) => reject(error);
		});

	onFileChange = async (e) => {
		if (e !== undefined) {
			e.preventDefault();
		}

		if (e.target.files[0] !== undefined) {
			if (checkMimeType(e)) {
				this.setState({ takePhotoModal: false, file: e.target.files[0] });

				this.openDocumentTypeModal();
			} else {
				toast.error(this.props.t("prescriptions.formatNotSupported"));
			}
			this.closeScanPrescriptionModalPopup();
		}
	};

	imageOnloadAutoScan = (image, file, documentTypeId) => {
		let barcode = "";
		const codeReader = new BrowserBarcodeReader();
		codeReader
			.decodeFromImage(image)
			.then((result) => {
				if (!result) toast.warn(this.props.t("prescriptions.noBarcodeFound"));
				else barcode = result.text;
			})
			.catch((err) => {
				if (err.name !== "NotFoundException") console.log("imageOnloadAutoScan error", { err });
				else {
					toast.warn(this.props.t("prescriptions.noBarcodeFound"));
				}
			})
			.finally(async () => {
				const res = await this.props.postScanPrescription(
					file,
					null, //verso
					barcode,
					this.props.prescription.id,
					this.props.prescription.folderId,
					documentTypeId
				);
				if (res.payload && barcode === "") {
					this.openQRReaderPrescription(res.payload?.data, this.props.prescription.scans.length + 1);
				}
			});
	};

	openPrescriptionViewModal = (scanId) => {
		this.closeQRReaderPrescription();
		this.setState({ scanPrescriptionViewOpen: true, scanId: scanId, movePrescriptionScan: this.props.movePrescriptionScan });
	};

	closePrescriptionViewModal = () => {
		this.setState({ scanPrescriptionViewOpen: false, scanId: null, movePrescriptionScan: null });
	};

	deleteScanPrescription = (prescriptionScan) => {
		this.setState({ scanPrescriptionViewOpen: false, scanId: null, movePrescriptionScan: null });

		this.props.deleteScanPrescription(prescriptionScan, this.props.prescription.id, this.props.prescription.folderId);
	};

	validateScanPrescription = (prescriptionScan) => {
		this.setState({ scanPrescriptionViewOpen: false, scanId: null, movePrescriptionScan: null });

		this.props.validateScanPrescription(prescriptionScan, this.props.prescription.id, this.props.prescription.folderId);
	};

	validateQualityScanPrescription = (prescriptionScan) => {
		this.setState({ scanPrescriptionViewOpen: false, scanId: null, movePrescriptionScan: null });

		this.props.validateQualityScanPrescription(prescriptionScan, this.props.prescription.id, this.props.prescription.folderId);
	};
	unvalidateQualityScanPrescription = (prescriptionScan) => {
		this.setState({ scanPrescriptionViewOpen: false, scanId: null, movePrescriptionScan: null });
		this.props.unvalidateQualityScanPrescription(prescriptionScan, this.props.prescription.id, this.props.prescription.folderId);
	};

	openTakePhotoModal = () => {
		this.setState({ takePhotoModal: true });
	};

	closeTakePhotoModal = () => {
		this.setState({ takePhotoModal: false });
	};

	submitTakePhotoModal = async (photo, barcode, documentType) => {
		this.setState({
			file: b64toFile(photo, "image/jpeg", 512),
			barcode: barcode,
		});
		await this.submitDocument(documentType);
	};

	submitScanOrdoModal = async (barcode, docType) => {
		if (docType === 1)
			this.setState({
				file: b64toFile(defaultCodeBarre, "image/png", 100),
				barcode: barcode,
			});
		else
			this.setState({
				file: b64toFile(documentCodeBar, "image/png", 100),
				barcode: barcode,
			});
		await this.submitDocument(docType);
		this.setState({ openScanOrdo: false });
	};

	addScanOrdoToPrescription = async (scan) => {
		await this.props.postScanPrescription(
			b64toFile(scan.rectoBase64, scan.format, 512, "scans-ordo.jpg"),
			scan.versoBase64 ? b64toFile(scan.versoBase64, scan.format, 512, "scans-ordo_back.jpg") : null,
			scan.barcodes,
			this.props.prescription.id,
			this.props.prescription.folderId,
			1,
			true
		);
		this.props.useScanOrdo(scan.id, this.props.prescription.id);
	};

	removeScanOrdoFromList = async (scan) => {
		this.props.removeScanOrdo(scan);
	};

	submitDocument = async (documentType) => {
		const { file, barcode } = this.state;
		if (barcode)
			this.props.postScanPrescription(
				file,
				null, //verso
				barcode,
				this.props.prescription.id,
				this.props.prescription.folderId,
				documentType
			);
		else if (file.type === "image/png" || file.type === "image/jpg" || file.type === "image/jpeg") {
			const image = new Image();
			image.src = await this.toBase64(file);
			image.onload = () => this.imageOnloadAutoScan(image, file, documentType);
		} else {
			toast.warn(this.props.t("prescriptions.cantScanBarcodePdf"));
			this.props.postScanPrescription(
				file,
				null, //verso
				"",
				this.props.prescription.id,
				this.props.prescription.folderId,
				documentType
			);
		}
		this.closeDocumentTypeModal();
	};

	closeQRReaderPrescription = () => {
		this.setState({
			qrReaderPrescriptionOpen: false,
			focusedScan: null,
			focusedPageNumber: null,
		});
	};

	openQRReaderPrescription = (scan, pageNumber) => {
		const scanAvailableState = {
			hasCameraAccess: true,
			qrReaderPrescriptionOpen: true,
			focusedScan: scan,
			focusedPageNumber: pageNumber,
		};
		this.setState(scanAvailableState);
	};

	submitQRReaderPrescription = (values) => {
		const { id } = this.state.focusedScan;
		const { focusedPageNumber } = this.state;
		const { scans } = this.props.prescription;
		this.props.setPrescriptionScanBarcode(id, values).then((res) => {
			if (res.payload?.status === 200) {
				const index = scans.findIndex((scan) => scan.id === id);
				if (index >= 0 && index < scans.length - 1) {
					for (let nextScanIndex = index + 1; nextScanIndex < scans.length; nextScanIndex++) {
						if (scans[nextScanIndex]?.barcode === null || scans[nextScanIndex]?.barcode === "") {
							this.openQRReaderPrescription(scans[nextScanIndex], focusedPageNumber + 1);
							return;
						}
					}
				}
				this.closeQRReaderPrescription();
			}
		});
	};

	openAnalysisDetailsModal = (analysis) => {
		this.setState({ analysisDetailsModal: true, analysisDetailed: analysis });
	};

	closeAnalysisDetailsModal = () => {
		this.setState({ analysisDetailsModal: false, analysisDetailed: null });
	};

	openHelpNurseModal = () => {
		this.setState({ helpNurseModal: true });
	};

	closeHelpNurseModal = () => {
		this.props.cleanScans();
		this.setState({ helpNurseModal: false });
	};

	closeScanDeleteConfirmOpen = () => {
		this.setState({ scanDeleteConfirmOpen: false, focusedScan: null });
	};

	openScanDeleteConfirmOpen = (scan) => {
		this.closeQRReaderPrescription();
		this.setState({ scanDeleteConfirmOpen: true, focusedScan: scan });
	};

	getDocumentsWaited = (prescription) => {
		return prescription.analyses.filter((a) => !!a.properties.documents).flatMap((analysis) => analysis.properties.documents);
	};

	getDocType = (doc) => {
		const { documentTypes } = this.props;
		return documentTypes.list.find((dt) => dt.name === doc)?.title || "Type de document inconnu";
	};
	isInPrescriptionScans = (barcode) => {
		return this.props.prescription.scans.some((scan) => scan.barcode === barcode);
	};
	// Check if a prescription is outdated
	isOutDated = (prescription) =>
		prescription.validity_date &&
		(moment(prescription.validity_date).isBefore(moment(), "date") ||
			(prescription.issue_date &&
				moment(prescription.issue_date).isSameOrBefore(moment(), "date") &&
				moment(prescription.validity_date).isAfter(moment(prescription.issue_date).add(6, "month"), "date")));
	isPostDated = (prescription) => prescription.issue_date && moment(prescription.issue_date).isAfter(moment(), "date");

	render() {
		let { prescription, disabled, folder, number, groupByDocumentType, getFPA, t, isThemeHospital, toggleContact } = this.props;

		const { focusedPageNumber, focusedScan, documentTypeModalOpen } = this.state;

		const isNotOriginal = prescription?.originalPrescription && prescription?.originalPrescription !== null;

		return (
			<>
				<div
					style={{
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
					}}
				>
					{this.state.qrReaderPrescriptionOpen && (
						<ScanContainer
							close={this.closeQRReaderPrescription}
							submit={this.submitQRReaderPrescription}
							regex={new RegExp(process.env.REACT_APP_BARCODE_REGEX.concat("$"))}
							cardContent={
								<>
									<Card.Header>{t("prescriptions.prescriptionNumber", { number: number, focusedPageNumber: focusedPageNumber })}</Card.Header>
									<Card.Meta>{focusedScan.filename}</Card.Meta>
									{focusedScan.barcode && <Card.Description>{t("prescriptions.barcode", { barcode: focusedScan.barcode })}</Card.Description>}
								</>
							}
						/>
					)}
				</div>
				{!prescription.show_mylab && !prescription.paper_copy_to_patient && (
					<Message warning header={t("prescriptions.warning")} content={t("prescriptions.patientWillReceiveNothing")} />
				)}
				<MainWhiteContainer onEdit={this.props.onEdit}>
					<Grid style={{ margin: 0, paddingRight: "1rem" }}>
						<Grid.Row style={{ paddingBottom: 0, paddingRight: "1rem" }}>
							<Grid.Column mobile={16} tablet={6} computer={7}>
								<div style={styles.doctor}>
									<span
										style={styles.prescriptionNumber}
										onClick={(e) => {
											if (e !== undefined) e.preventDefault();
											getFPA(prescription.id).then((res) => {
												const linkSource = `data:application/pdf;base64,${res.payload.data.base64}`;
												const downloadLink = document.createElement("a");
												const fileName = `fpa-${prescription.id}.pdf`;
												downloadLink.href = linkSource;
												downloadLink.download = fileName;
												downloadLink.click();
											});
										}}
									>
										{t("prescriptions.number", { number: number })}
									</span>
									{prescription.no_prescriber && <span style={styles.textField}>{t("prescriptions.patientWithoutPrescription")}</span>}
									{!prescription.no_prescriber && (
										<div style={{ display: "flex", flexDirection: "column" }}>
											<span style={styles.textField}>
												<Icon name="user doctor" />
												{t("prescriptions.doctor")}
												{prescription.prescriber?.title} {prescription.prescriber?.last_name} {prescription.prescriber?.first_name}
												{prescription.prescriber_to_create_by_secretary && t("prescriptions.doctorToBeCreated")}
											</span>
											<span style={styles.textField}>
												<Icon name="map marker alternate" /> {prescription.prescriber?.number || ""} {prescription.prescriber?.street || ""} <br />
												{prescription.prescriber?.complement && (
													<>
														{prescription.prescriber?.complement} <br />
													</>
												)}
												{prescription.prescriber?.postal_code || ""} {prescription.prescriber?.city || ""}
											</span>
										</div>
									)}
								</div>
							</Grid.Column>

							<Grid.Column mobile={8} tablet={4} computer={3}>
								<ContainerFieldPrescription
									field={prescription.issue_date ? moment(prescription.issue_date).format(process.env.REACT_APP_DATE_DISPLAY_FORMAT) : null}
									extra={
										this.isPostDated(prescription) ? (
											<Label color="red" style={{ marginLeft: "3px" }}>
												{t("prescriptions.postdated")}
											</Label>
										) : null
									}
									label={t("prescriptions.issuance")}
								/>
							</Grid.Column>
							<Grid.Column mobile={8} tablet={4} computer={4}>
								<ContainerFieldPrescription
									field={prescription.validity_date ? moment(prescription.validity_date).format(process.env.REACT_APP_DATE_DISPLAY_FORMAT) : null}
									extra={
										this.isOutDated(prescription) ? (
											<Label color="red" style={{ marginLeft: "3px" }}>
												{t("prescriptions.expired")}
											</Label>
										) : null
									}
									colorExtra="red"
									label={t("prescriptions.validity")}
								/>
							</Grid.Column>

							<Grid.Column mobile={16} tablet={2} computer={2}>
								<BlueButtonEditBloc
									onClick={(e) => {
										if (e !== undefined) e.preventDefault();
										this.props.onEdit();
									}}
									text={t(!disabled ? "prescriptions.edit" : "prescriptions.show")}
									style={{ margin: isMobile() ? "10px 33%" : "-10px .25em 0 0", float: isMobile() ? "none" : "right" }}
								/>
							</Grid.Column>
						</Grid.Row>

						<Grid.Row style={styles.rowNoPadding}>
							<Separator />
						</Grid.Row>
						{(prescription.urgent || prescription.accident || prescription.provider_barcode) && (
							<Grid.Row style={styles.rowNoPadding}>
								{prescription.urgent && (
									<Grid.Column mobile={8} tablet={5} computer={5} style={{ padding: "5px 0" }}>
										<ContainerFieldPrescriptionUrgent field={prescription.urgent} extra={prescription.reason} label={t("prescriptions.urgent")} />
									</Grid.Column>
								)}
								{prescription.accident && (
									<Grid.Column mobile={8} tablet={5} computer={5} style={{ padding: "5px 0" }}>
										<ContainerFieldPrescription
											field={prescription.accident ? t("prescriptions.accidentNumber", { accidentNumber: prescription.accident_number }) : ""}
											extra={prescription.accident_date ? moment(prescription.accident_date).format(process.env.REACT_APP_DATE_DISPLAY_FORMAT) : ""}
											label={t("prescriptions.accident")}
										/>
									</Grid.Column>
								)}
								{prescription.provider_barcode && (
									<Grid.Column mobile={8} tablet={5} computer={5} style={{ padding: "5px 0" }}>
										<ContainerFieldPrescription field={prescription.provider_barcode} label={t("prescriptions.eprescriptionCode")} />
									</Grid.Column>
								)}
							</Grid.Row>
						)}

						{/* {prescription.comment !== null && prescription.comment !== '' && (
							<Grid.Row>
								<Grid.Column style={{ padding: '5px 10px' }}>
									<span style={{ fontSize: '1em', fontWeight: 600 }}>
										{prescription.comment}
									</span>
								</Grid.Column>
							</Grid.Row>
						)} */}

						<Grid.Row style={styles.rowNoPadding}>
							{prescription.reference && (
								<Grid.Column mobile={8} tablet={5} computer={5} style={{ padding: "5px 0" }}>
									<ContainerFieldPrescription field={prescription.reference} extra={null} label={t("prescriptions.ref")} />
								</Grid.Column>
							)}
							{prescription.repeatable && (
								<Grid.Column mobile={8} tablet={5} computer={5} style={{ padding: "5px 0" }}>
									<ContainerFieldPrescription field={`N° ${prescription.repetitionNumber}`} extra={null} label={t("prescriptions.repetition")} />
								</Grid.Column>
							)}
						</Grid.Row>
						{(prescription.sampler || prescription.billing_company) && (
							<Grid.Row style={styles.rowNoPadding}>
								{prescription.sampler && (
									<Grid.Column mobile={8} tablet={5} computer={5} style={{ padding: "5px 0" }}>
										<ContainerFieldPrescription
											field={`${prescription.sampler.last_name} ${prescription.sampler.first_name}`}
											extra={null}
											label={t("prescriptions.sampler")}
										/>
									</Grid.Column>
								)}
								{prescription.billing_company && (
									<Grid.Column mobile={8} tablet={11} computer={11} style={{ padding: "5px 0" }}>
										<ContainerFieldPrescription
											field={`${prescription.billing_company?.type ? `${prescription.billing_company?.type} - ` : ""} ${
												prescription.billing_company?.name
											} ${prescription.billing_company?.department ? ` - ${prescription.billing_company?.department}` : ""}`}
											extra={null}
											label={t("prescriptions.billingCompany")}
										/>
									</Grid.Column>
								)}
							</Grid.Row>
						)}
						{!isThemeHospital && (
							<>
								<Grid.Row style={styles.rowNoPadding}>
									<Separator />
								</Grid.Row>

								<Grid.Row style={{ padding: !prescription.no_prescriber ? "20px 0px" : "10px 0px" }}>
									<Grid.Column mobile={8} tablet={5} computer={2} style={{ padding: "5px 20px" }}>
										<div style={styles.doctor}>
											<Icon name="sliders horizontal" />
											<span>{t("prescriptions.resultCommunication")}</span>
										</div>
									</Grid.Column>
									<Grid.Column mobile={8} tablet={5} computer={10}>
										<Grid>
											{!prescription.no_prescriber && (
												<Grid.Row style={styles.rowNoPadding}>
													<Grid.Column mobile={8} tablet={5} computer={3} style={{ padding: "5px 0", textAlign: "right" }}>
														<span style={{ paddingLeft: 10, paddingBottom: 5, fontSize: "1em", width: "100%" }}>
															<Icon name="user doctor" />
															{t("prescriptions.prescriber")}
														</span>
													</Grid.Column>
													<Grid.Column mobile={8} tablet={5} computer={1} style={{ padding: "5px 0", textAlign: "right" }}>
														<Icon name="arrow alternate circle right" />
													</Grid.Column>
													<Grid.Column mobile={8} tablet={5} computer={5} style={{ padding: "5px 0" }}>
														<ContainerIconPrescription
															iconName="phone"
															field={prescription.to_be_phoned}
															extra={
																prescription.to_be_phoned && prescription.to_be_phoned_number
																	? formatPhoneNumberToInternational(prescription.to_be_phoned_number)
																	: ""
															}
															secondExtra={
																prescription.to_be_phoned_number
																	? prescription.phone_before &&
																	  "avant " +
																			moment({
																				hour: prescription.phone_before.substring(0, 2),
																				minute: prescription.phone_before.substring(3, 5),
																			}).format(process.env.REACT_APP_TIME_DISPLAY_FORMAT)
																	: ""
															}
															conditionToggle={!!prescription.to_be_phoned_number || !!prescription.prescriber?.phone}
															toggleOnClick={() => toggleContact(prescription.id, "to_be_phoned")}
															popupExtra={
																formatPhoneNumberToInternational(prescription.to_be_phoned_number || prescription?.prescriber?.phone)
																	? `Par téléphone au ${formatPhoneNumberToInternational(
																			prescription.to_be_phoned_number || prescription?.prescriber?.phone
																	  )}`
																	: "Pas de téléphone connu pour ce médecin."
															}
														/>
													</Grid.Column>
													<Grid.Column mobile={8} tablet={5} computer={5} style={{ padding: "5px 0" }}>
														<ContainerIconPrescription
															iconName="fax"
															field={prescription.to_be_faxed}
															extra={prescription.to_be_faxed_number ? formatPhoneNumberToInternational(prescription.to_be_faxed_number) : ""}
															secondExtra={
																prescription.to_be_faxed
																	? prescription.fax_before &&
																	  "avant " +
																			moment({
																				hour: prescription.fax_before.substring(0, 2),
																				minute: prescription.fax_before.substring(3, 5),
																			}).format(process.env.REACT_APP_TIME_DISPLAY_FORMAT)
																	: ""
															}
															conditionToggle={!!prescription.to_be_faxed_number}
															toggleOnClick={() => toggleContact(prescription.id, "to_be_faxed")}
															popupExtra={
																!!prescription.to_be_faxed_number
																	? `Par fax au ${formatPhoneNumberToInternational(prescription.to_be_faxed_number)}`
																	: "Pas de numéro de fax connu pour ce médecin."
															}
														/>
													</Grid.Column>
													<Grid.Column mobile={8} tablet={5} computer={2} style={{ padding: "5px 0" }}></Grid.Column>
												</Grid.Row>
											)}
											{!prescription.no_prescriber && (
												<Grid.Row style={styles.rowNoPadding}>
													<Separator />
												</Grid.Row>
											)}
											<Grid.Row style={!prescription.no_prescriber ? styles.rowNoPadding : styles.rowWithPadding}>
												<Grid.Column mobile={8} tablet={5} computer={3} style={{ padding: "5px 0", textAlign: "right" }}>
													<span style={{ paddingLeft: 10, paddingBottom: 5, fontSize: "1em", width: "100%" }}>
														<Icon name="user" />
														{t("prescriptions.Patient")}
													</span>
												</Grid.Column>
												<Grid.Column mobile={8} tablet={5} computer={1} style={{ padding: "5px 0", textAlign: "right" }}>
													<Icon name="arrow alternate circle right" />
												</Grid.Column>
												<Grid.Column mobile={8} tablet={5} computer={5} style={{ padding: "5px 0" }}>
													<ContainerIconPrescription
														iconName="phone"
														field={prescription.phone_to_patient}
														extra={prescription.phone_to_patient ? formatPhoneNumberToInternational(prescription.phone_to_patient_number) : ""}
														conditionToggle={
															!!prescription.phone_to_patient_number ||
															!!cleanPhoneNumber(this.props.patient.mobile_phone) ||
															!!cleanPhoneNumber(this.props.patient.phone)
														}
														toggleOnClick={() => {
															if (prescription.phone_to_patient_number || this.props.patient.mobile_phone || this.props.patient.phone) {
																toggleContact(prescription.id, "phone_to_patient");
															}
														}}
														popupExtra={
															!!(prescription.phone_to_patient_number || this.props.patient.mobile_phone || this.props.patient.phone)
																? `Par téléphone au ${formatPhoneNumberToInternational(
																		prescription.phone_to_patient_number || this.props.patient.mobile_phone || this.props.patient.phone
																  )}`
																: "Numéro de téléphone du patient à vérifier au niveau de la prescription."
														}
													/>
												</Grid.Column>
												<Grid.Column mobile={8} tablet={5} computer={5} style={{ padding: "5px 0" }}>
													<ContainerIconPrescription
														iconName="envelope outline"
														field={prescription.paper_copy_to_patient}
														extra={prescription.paper_copy_to_patient ? "Copie à l'adresse du patient" : null}
														conditionToggle={!!this.props.patient?.home_street}
														toggleOnClick={() => toggleContact(prescription.id, "paper_copy_to_patient")}
														popupExtra={
															!!this.props.patient?.home_street ? (
																<>Par courrier à : {getPatientHomeAddress(this.props.patient)}</>
															) : (
																"Adresse du patient à vérifier"
															)
														}
													/>
												</Grid.Column>
											</Grid.Row>
										</Grid>
									</Grid.Column>
								</Grid.Row>
								{prescription.doctorCopy_to_create_by_secretary && (
									<Grid.Column key="tobecreateddoctor" mobile={8} tablet={5} computer={5} style={{ padding: "5px 0" }}>
										<ContainerFieldPrescription
											field={t("prescriptions.doctorInCopyToBeCreated")}
											extra={null}
											label={t("prescriptions.doctorInCopy")}
										/>
									</Grid.Column>
								)}

								{prescription.carbonCopyDoctors &&
									prescription.carbonCopyDoctors.map((ccDoc) => (
										<Grid.Column key={ccDoc.id} mobile={8} tablet={5} computer={5} style={{ padding: "5px 0" }}>
											{ccDoc.doctor && (
												<ContainerFieldPrescription
													field={`${ccDoc.doctor.title ?? ""} ${ccDoc.doctor.last_name} ${ccDoc.doctor.first_name}`}
													extra={null}
													label={t("prescriptions.doctorInCopy")}
												/>
											)}

											<ContainerFieldPrescription
												field={ccDoc.to_be_faxed}
												extra={ccDoc.to_be_faxed ? formatPhoneNumberToInternational(ccDoc.to_be_faxed_number) : ""}
												label={t("prescriptions.perFax")}
											/>

											<ContainerFieldPrescription
												field={ccDoc.to_be_phoned}
												extra={ccDoc.to_be_phoned ? formatPhoneNumberToInternational(ccDoc.to_be_phoned_number) : ""}
												label={t("prescriptions.perPhone")}
											/>
										</Grid.Column>
									))}

								<Grid.Row style={styles.rowNoPadding}>
									<Separator />
								</Grid.Row>
								{folder.is_express && Object.entries(folder.cb_express)?.length > 0 && (
									<>
										<Grid.Row columns={1} style={{ paddingBottom: 10, marginTop: 5 }}>
											<Grid.Column mobile={9} tablet={9} computer={9} style={{ padding: "5px 10px" }}>
												<div style={styles.title}>
													<div>Dépôt express - code-barres enregistré(s) lors de la création :</div>
													<div>
														{Object.entries(folder.cb_express).map(([key, value]) => (
															<div key={`express${key}${value}`}>
																<Label color={this.isInPrescriptionScans(value) ? "green" : "red"}>
																	{this.getDocType(key)}
																	<LabelDetail>{value}</LabelDetail>
																</Label>
															</div>
														))}
													</div>
												</div>
											</Grid.Column>
										</Grid.Row>
										<Grid.Row style={styles.rowNoPadding}>
											<Separator />
										</Grid.Row>
									</>
								)}
								<Grid.Row columns={2} style={{ paddingBottom: 0, marginTop: 5 }}>
									<Grid.Column mobile={9} tablet={9} computer={9} style={{ padding: "5px 10px" }}>
										<div style={styles.doctor}>
											<span>
												<Icon name="address card" /> {t("prescriptions.documents")}
												{this.getDocumentsWaited(prescription).length > 0 && (
													<div style={{ color: "teal", fontSize: "0.8rem", paddingLeft: "5px" }}>
														{t("prescriptions.documentsWaited")} :{" "}
														{this.getDocumentsWaited(prescription).map((doc, index) => (
															<Label key={`doc-${index}`} as="a" target="_blank" href={`${process.env.REACT_APP_BASE_URL}/pdf/${doc.name}_fr.pdf`}>
																{doc.title} <Icon name="download" />
															</Label>
														))}
													</div>
												)}
											</span>
										</div>
									</Grid.Column>
									<Grid.Column
										mobile={16}
										tablet={7}
										computer={7}
										style={{
											display: "flex",
											justifyContent: !isMobile() ? "flex-end" : "center",
											alignItems: "stretch",
											flexWrap: !isMobile() ? "nowrap" : "wrap",
										}}
									>
										{/* <input
									type="file"
									id="my_folder_input"
									ref="folderUploader"
									style={{ opacity: "0", height: 0, width: 0 }}
									onChange={(e) => this.onFileChange(e)}
								/>
								<label htmlFor="my_folder_input">
									<BlueButtonEditBloc
										onClick={(e) => {
											if (e !== undefined) e.preventDefault();
											this.refs.folderUploader.click();
										}}
										text={t("prescriptions.import")}
										style={{ display: "flex", flexGrow: 4, flexShrink: 0 }}
										disabled={disabled || isNotOriginal}
									/>
								</label> */}

										{/* <BlueButtonEditBloc
									onClick={(e) => {
										if (e !== undefined) e.preventDefault();
										this.openTakePhotoModal();
										this.closeScanPrescriptionModalPopup();
									}}
									text='Prendre en photo'
									style={{ display: 'flex', flexGrow: 4, flexShrink: 0 }}
									
									disabled={disabled || isNotOriginal}
								/>  */}
										<BlueButtonEditBloc
											onClick={(e) => {
												if (e !== undefined) e.preventDefault();
												this.setState({ addDocsModalOpen: true });
											}}
											text="Documents scannés en centre"
											style={{ display: "flex", flexGrow: 4, flexShrink: 0 }}
											disabled={disabled || isNotOriginal}
										/>
										<BlueButtonEditBloc
											onClick={(e) => {
												if (e !== undefined) e.preventDefault();
												this.setState({ openScanOrdo: true });
											}}
											text={t("prescriptions.scanBarcode")}
											style={{ display: "flex" }}
											disabled={disabled || isNotOriginal}
										/>
									</Grid.Column>
								</Grid.Row>
								<Grid.Row columns={1}>
									<Grid.Column style={{ display: "flex" }}>
										<Documents
											prescription={prescription}
											groupByDocumentType={groupByDocumentType}
											focusedScan={focusedScan}
											disabled={disabled}
											isNotOriginal={isNotOriginal}
											openPrescriptionViewModal={this.openPrescriptionViewModal}
											openScanDeleteConfirmOpen={this.openScanDeleteConfirmOpen}
											openQRReaderPrescription={this.openQRReaderPrescription}
											movePrescriptionScan={this.props.movePrescriptionScan}
										/>
									</Grid.Column>
								</Grid.Row>
							</>
						)}

						<Grid.Row style={styles.rowNoPadding}>
							<Separator />
						</Grid.Row>

						<Grid.Row columns={1} style={{ paddingBottom: 5 }}>
							<Grid.Column>
								<div style={styles.doctor}>
									<Icon name="lab"></Icon>
									<span style={styles.textField}>{t("prescriptions.analysis")}</span>
									{this.props.role === "NURSE" && prescription.analyses.length > 0 && prescription.analyses.some((a) => !a.checked_by) && (
										<span style={{ color: "teal", fontSize: "0.8rem", paddingLeft: "5px" }}>
											(Utilisez les cases à cocher pour vérifier la saisie des analyses et afficher les tubes à prélever.)
										</span>
									)}
									{this.props.role === "NURSE" && prescription.analyses.length > 0 && !prescription.analyses.some((a) => !a.checked_by) && (
										<span style={{ color: "teal", fontSize: "0.8rem", paddingLeft: "5px" }}>
											(La saisie des analyses a été vérifiée, les tubes à prélever sont visibles.)
										</span>
									)}
								</div>
							</Grid.Column>
						</Grid.Row>

						<Grid.Row columns={1} style={{ paddingTop: 5 }}>
							{!this.props.isLoading && (
								<Grid.Column style={{ display: "flex", flexDirection: "column" }} mobile={16} tablet={16} computer={16}>
									{prescription.analyses
										.sort((a, b) => (a.order < b.order ? -1 : a.order > b.order ? 1 : 0))
										.map((ana) => (
											<Analysis
												key={ana.id}
												analysis={ana}
												onClick={this.openAnalysisDetailsModal}
												showWarning={false}
												showLabel={true}
												isHome={folder.isHome}
												isMobile={isMobile()}
												showRefused={false}
												isRefused={ana.refused_patient}
												toggleRefused={() => (ana.refused_patient = !ana.refused_patient)}
												disabled={disabled}
												withCheckBox={this.props.role === "NURSE" && prescription.analyses.some((a) => !a.checked_by)}
												checkAnalysis={(p) => this.props.checkAnalysis(folder.id, prescription.id, ana.id, p)}
											/>
										))}
								</Grid.Column>
							)}
						</Grid.Row>

						{!isThemeHospital && (
							<Grid.Row columns={2} style={{ paddingTop: 5 }}>
								<Grid.Column style={{ display: "flex" }}>
									<BlueButton
										onClick={(e) => {
											this.openAnalysesEdit(e);
										}}
										text={t("prescriptions.editAnalysis")}
										disabled={disabled || isNotOriginal}
									/>
								</Grid.Column>
								{this.props.role === "NURSE" && this.props.center && this.props.center.isTvSecActivated && (
									<Grid.Column
										style={{
											display: "flex",
											flexDirection: "row",
											justifyContent: "flex-end",
										}}
									>
										<Popup
											content={t("prescriptions.secretaryHelpContentHelp")}
											header={t("prescriptions.secretaryHelpHeader")}
											position="top left"
											basic
											trigger={
												<span>
													<BlueButton
														style={{
															width: isMobile() ? "95%" : "100%",
															alignSlef: "center",
														}}
														onClick={() => {
															this.openHelpNurseModal(folder);
														}}
														text={
															<>
																<Icon name="bell" /> {t("prescriptions.telesecretariat")}
															</>
														}
														disabled={disabled || isNotOriginal}
													/>
												</span>
											}
										/>
										<AddNurseHelpModal
											open={this.state.helpNurseModal}
											close={this.closeHelpNurseModal}
											createFolderHelp={this.props.createFolderHelp}
											folder={folder}
											scans={this.props.scans}
											addScanOrdoToPrescription={this.addScanOrdoToPrescription}
											removeScanOrdoFromList={this.removeScanOrdoFromList}
											docs={prescription?.scans}
											loadingScans={this.props.loadingScans}
											deleteScanPrescription={this.deleteScanPrescription}
											center={this.props.center}
											secretaries={this.props.secretaries}
											tvsec={true}
											deposit={false}
											documentTypeOptions={this.props.documentTypes?.list}
											getAllDocumentTypes={this.props.getAllDocumentTypes}
										/>
									</Grid.Column>
								)}
							</Grid.Row>
						)}
					</Grid>

					<ViewFilesModal
						open={this.state.scanPrescriptionViewOpen}
						close={this.closePrescriptionViewModal}
						files={prescription?.scans}
						deleteFile={this.deleteScanPrescription}
						fileIndex={this.state.scanId}
						disabled={disabled}
						isNotOriginal={isNotOriginal}
						validateScanPrescription={this.validateScanPrescription}
						deleteScanPrescription={this.deleteScanPrescription}
						validateQualityScanPrescription={this.validateQualityScanPrescription}
						unvalidateQualityScanPrescription={this.unvalidateQualityScanPrescription}
						telesec={this.props.folder.status === "HELP_NURSE"}
						movePrescriptionScan={{ ...this.state.movePrescriptionScan, close: this.closePrescriptionViewModal }}
					/>
					{this.state.takePhotoModal && (
						<TakePhotoModal
							open={this.state.takePhotoModal}
							close={this.closeTakePhotoModal}
							submit={this.submitTakePhotoModal}
							documentTypeOptions={this.props.documentTypes?.list}
							defaultDocumentTypeValue={this.props.documentTypes?.list.find((type) => type.is_prescription_default)?.id}
						/>
					)}

					<QRScanCodeBarreOrdonance
						open={this.state.openScanOrdo}
						close={() => this.setState({ openScanOrdo: false })}
						submit={this.submitScanOrdoModal}
						hasCameraAccess={this.state.hasCameraAccess}
						documentTypeOptions={this.props.documentTypes?.list}
						defaultDocumentTypeValue={this.props.documentTypes?.list.find((type) => type.is_prescription_default)?.id}
					/>

					<AnalysisDetailsModal
						open={this.state.analysisDetailsModal}
						close={this.closeAnalysisDetailsModal}
						analysis={this.state.analysisDetailed}
						isHome={folder.isHome}
					/>

					<SignConsentModal
						open={this.state.signConsentModalOpen}
						close={this.closeSignConsentModal}
						onSubmit={this.saveConsentPDF}
						consentRefusalReasons={this.props.consentRefusalReasons}
					/>
					{documentTypeModalOpen && (
						<DocumentTypeModal
							close={this.closeDocumentTypeModal}
							options={this.props.documentTypes?.list}
							submit={this.submitDocument}
							defaultValue={this.props.documentTypes?.list.find((type) => type.is_prescription_default)?.id}
						/>
					)}
					<AddDocsTvSecModal
						open={this.state.addDocsModalOpen}
						close={() => {
							this.props.cleanScans();
							this.setState({ addDocsModalOpen: false });
						}}
						folder={folder}
						getScansForTVsecretariat={this.props.getScansForTVsecretariat}
						refreshCenterScans={this.props.refreshCenterScans}
						scans={this.props.scans}
						addScanOrdoToPrescription={this.addScanOrdoToPrescription}
						prescriptions={folder.prescriptions}
						docs={folder.prescriptions?.flatMap((p) => p.scans) || []}
						loadingScans={this.props.loadingScans}
					/>

					<Confirm
						open={this.state.scanDeleteConfirmOpen}
						onCancel={this.closeScanDeleteConfirmOpen}
						onConfirm={() => {
							this.deleteScanPrescription(focusedScan);
							this.closeScanDeleteConfirmOpen();
						}}
						content={t("prescriptions.confirmDeleteScan")}
						cancelButton={t("prescriptions.cancel")}
						confirmButton={t("prescriptions.confirm")}
					/>
				</MainWhiteContainer>
			</>
		);
	}
}

export default withTranslation()(Prescription);
